import { UserMentionsResponseSchema } from '@sweetistics/contracts';
import type { z } from 'zod';

export type UserMentionsResponseInput = z.input<typeof UserMentionsResponseSchema>;
export type UserMentionsResponseOutput = z.output<typeof UserMentionsResponseSchema>;

export function serializeUserMentionsResponse(payload: UserMentionsResponseInput): UserMentionsResponseOutput {
  const pagination = {
    cursor: payload.pagination?.cursor ?? null,
    hasMore: payload.pagination?.hasMore ?? false,
    totalCount: payload.pagination?.totalCount ?? null,
    page: payload.pagination?.page,
    limit: payload.pagination?.limit,
  } satisfies UserMentionsResponseInput['pagination'];

  return UserMentionsResponseSchema.parse({
    ...payload,
    pagination,
  });
}
